import React from 'react';

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-surface flex flex-col">
      {/* Header Skeleton */}
      <header className="sticky top-0 z-50 bg-surface border-b border-surface-container-highest">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="h-8 w-40 bg-stone-200 rounded animate-shimmer"></div>
          <div className="hidden md:flex items-center space-x-8">
            <div className="h-6 w-16 bg-stone-200 rounded animate-shimmer"></div>
            <div className="h-6 w-20 bg-stone-200 rounded animate-shimmer"></div>
            <div className="h-6 w-14 bg-stone-200 rounded animate-shimmer"></div>
          </div>
          <div className="w-10 h-10 bg-stone-200 rounded-full animate-shimmer"></div>
        </div>
      </header>

      {/* Main Content Skeleton */}
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mx-auto mb-6"></div>
        </div>
      </main>

      {/* Footer Skeleton */}
      <footer className="bg-surface-container-low py-8 border-t border-surface-container-highest">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="h-6 w-32 bg-stone-200 rounded animate-shimmer"></div>
          <div className="flex gap-6">
            <div className="h-5 w-20 bg-stone-200 rounded animate-shimmer"></div>
            <div className="h-5 w-20 bg-stone-200 rounded animate-shimmer"></div>
            <div className="h-5 w-24 bg-stone-200 rounded animate-shimmer"></div>
          </div>
          <div className="h-5 w-40 bg-stone-200 rounded animate-shimmer"></div>
        </div>
      </footer>
    </div>
  );
}

export default LoadingScreen;
